module.exports = __webpack_public_path__ + "img/Liberia.92c318cc.gif";